<template>
  <v-container
    id="training-providers-view"
    fluid
    tag="section"
  >
    <v-row align="center">
      <v-col
        cols="6"
      >
        <p class="mb-0 d-inline-block text-h4">
          Proveedores de Capacitación Externa
        </p>
      </v-col>
      <v-col
        cols="6"
      >
        <div class="pb-2 text-right">
          <v-btn
            small
            color="success"
            min-width="100"
            class="mr-2"
            @click="openImportDialog()"
          >
            <v-icon left>
              mdi-file-excel
            </v-icon>
            Importar Excel
          </v-btn>
          <v-btn
            small
            color="info"
            min-width="100"
            class="mr-2"
            @click="addData()"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Nuevo proveedor
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-divider class="mb-6 secondary" />
    <div class="mb-3 mt-3">
      &nbsp;
    </div>
    <material-card
      icon="mdi-domain"
      icon-small
      color="primary"
      title="Listado de proveedores"
    >
      <v-card-text>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          hide-details
          label="Buscar registros"
          single-line
          style="max-width: 250px;"
        />

        <v-divider class="mt-3" />

        <v-data-table
          :headers="headers"
          :items="items"
          :search.sync="search"
          multi-sort
          must-sort
          :footer-props="{
            showFirstLastPage: true,
            'itemsPerPageText':'Proveedores por página'
          }"
        >
          <template slot="no-data">
            No hay datos para mostrar
          </template>
          <template slot="no-results">
            No hay resultados para mostrar
          </template>
          <template v-slot:[`item.actions`]="data">
            <div>
              <app-btn
                color="info"
                class="px-2 ml-1"
                elevation="0"
                min-width="0"
                small
                @click="editData(data.item)"
              >
                <v-icon
                  small
                  v-text="'mdi-pencil'"
                />
              </app-btn>
              <app-btn
                color="error"
                class="px-2 ml-1"
                elevation="0"
                min-width="0"
                small
                @click="openConfirm(data.item)"
              >
                <v-icon
                  small
                  v-text="'mdi-delete'"
                />
              </app-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
    <v-dialog
      v-model="displayDialog"
      persistent
      max-width="600"
    >
      <material-card
        full-header
        light
        inline
        color="info"
        class="mx-auto"
      >
        <template #heading>
          <div class="text-center pa-5">
            <div class="text-h4 white--text">
              Proveedor de Capacitación
            </div>
          </div>
        </template>
        <v-card-text>
          <v-form>
            <v-row align="center">
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="item.name"
                  class="mb-n3"
                  label="Nombre Comercial"
                  type="text"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="item.business_name"
                  class="mb-n3"
                  label="Razón Social"
                  type="text"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="item.rfc"
                  class="mb-n3"
                  label="RFC"
                  type="text"
                  maxlength="20"
                />
              </v-col>
            </v-row>
          </v-form>
          <div class="pa-3 text-center mt-2">
            <v-btn
              small
              color="error"
              min-width="100"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
            <v-btn
              small
              color="success"
              class="ml-2"
              min-width="100"
              @click="store()"
            >
              Guardar
            </v-btn>
          </div>
        </v-card-text>
      </material-card>
    </v-dialog>
    <v-overlay
      class="v-overlay-custom"
      :value="overlay"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <material-snackbar
      v-model="snackbar.display"
      :type="snackbar.type"
      timeout="10000"
      v-bind="{
        ['top']: true,
        ['right']: true
      }"
    >
      <div>
        <span class="font-weight-bold">&nbsp;{{ snackbar.title }}&nbsp;</span> <span v-html="snackbar.message" />
      </div>
    </material-snackbar>
    <!-- DIALOGO DE CONFIRMACIÓN -->
    <v-dialog
      v-model="confirm"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h4">
          Confirmación
        </v-card-title>
        <v-card-text>
          <span class="text-h5">
            ¿Está seguro de eliminar el proveedor?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning"
            small
            @click="confirm = false"
          >
            No
          </v-btn>
          <v-btn
            color="success"
            small
            @click="deleteData()"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOGO DE IMPORTACIÓN -->
    <v-dialog
      v-model="importDialog"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h4">
          Importar Proveedores desde Excel
        </v-card-title>
        <v-card-text>
          <v-alert
            dense
            outlined
            class="mb-4"
            color="error"
            icon="mdi-alert-circle"
          >
            <div class="mb-2 red--text">
              <strong>Instrucciones del archivo Excel:</strong>
            </div>
            <div class="mb-1">
              La primera fila debe contener los encabezados de las columnas:
            </div>
            <ul class="mb-2">
              <li><strong>nombre</strong> (obligatorio) - Nombre comercial del proveedor</li>
              <li><strong>razon_social</strong> (opcional) - Razón social</li>
              <li><strong>rfc</strong> (opcional) - RFC del proveedor (debe ser único)</li>
            </ul>
            <div>
              Los proveedores con nombre o RFC duplicado serán omitidos automáticamente.
            </div>
          </v-alert>
          <v-file-input
            v-model="excelFile"
            label="Seleccionar archivo Excel"
            accept=".xlsx,.xls"
            prepend-icon="mdi-file-excel"
            outlined
            show-size
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            small
            @click="closeImportDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            small
            :disabled="!excelFile"
            @click="importExcel()"
          >
            Importar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import TrainingProviderService from '../services/TrainingProviderService';
  import { getErrorMessage } from '@/util/helpers';
  import { get } from 'vuex-pathify';
  export default {
    name: 'TrainingProvidersView',
    data: () => ({
      headers: [
        {
          text: 'ID',
          value: 'id',
          width: '5%',
        },
        {
          text: 'Nombre Comercial',
          value: 'name',
          width: '30%',
        },
        {
          text: 'Razón Social',
          value: 'business_name',
          width: '30%',
        },
        {
          text: 'RFC',
          value: 'rfc',
          width: '20%',
        },
        {
          sortable: false,
          text: 'Opciones',
          value: 'actions',
          width: '15%',
          align: 'center',
        },
      ],
      items: [],
      item: {
        id: null,
        name: null,
        business_name: null,
        rfc: null,
      },
      rules: {
        required: value => !!value || 'Campo requerido.',
      },
      displayDate: false,
      dialog: false,
      trainingProviderService: null,
      search: undefined,
      overlay: false,
      displayDialog: false,
      disabled: false,
      isEdit: false,
      confirm: false,
      importDialog: false,
      excelFile: null,
      snackbar: {
        display: false,
        title: null,
        type: 'success',
        message: null,
      },
    }),
    computed: {
      ...get('session', [
        'userInfo',
      ]),
    },
    created () {
      this.trainingProviderService = new TrainingProviderService();
    },
    mounted () {
      this.loadData();
    },
    methods: {
      loadData () {
        this.overlay = true;
        this.trainingProviderService.all().then(response => {
          this.items = response.data;
          this.overlay = false;
        }).catch((error) => {
          console.log(error);
          this.overlay = false;
        });
      },
      addData () {
        this.overlay = true;
        this.item.name = null;
        this.item.business_name = null;
        this.item.rfc = null;
        this.displayDialog = true;
        this.overlay = false;
        this.isEdit = false;
      },
      editData (item) {
        this.overlay = true;
        this.isEdit = true;
        this.item = Object.assign({}, item);
        this.overlay = false;
        this.displayDialog = true;
      },
      openConfirm (item) {
        this.item = Object.assign({}, item);
        this.confirm = true;
      },
      store () {
        if (!this.item.name || this.item.name.trim() === '') {
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: 'El nombre comercial del proveedor es obligatorio.',
          };
          return;
        }

        if (!this.isEdit) this.saveData();
        else this.updateData();
      },
      saveData () {
        // GUARDAR SOLICTUD
        this.overlay = true;
        const model = Object.assign({}, this.item);
        this.trainingProviderService.create(this.item).then(response => {
          this.overlay = false;
          this.item = {};
          this.displayDialog = false;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'INFO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          this.overlay = false;
          this.item = model;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response.data.message),
          };
          this.displayDialog = true;
        });
      },
      updateData () {
        // ACTUALIZAR SOLICTUD
        this.overlay = true;
        const model = Object.assign({}, this.item);
        this.trainingProviderService.update(this.item, this.item.id).then(response => {
          this.overlay = false;
          this.displayDialog = false;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'INFO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          console.log(error);
          this.item = model;
          this.overlay = false;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response.data.message),
          };
          this.displayDialog = true;
        });
      },
      deleteData () {
        // UPDATE
        this.overlay = true;
        this.trainingProviderService.delete(this.item.id).then(response => {
          this.overlay = false;
          this.item = {};
          this.confirm = false;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'INFO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          this.confirm = false;
          this.overlay = false;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response.data.message),
          };
        });
      },
      closeDialog () {
        this.item = {};
        this.disabled = true;
        this.displayDialog = false;
        this.overlay = false;
      },
      openImportDialog () {
        this.excelFile = null;
        this.importDialog = true;
      },
      closeImportDialog () {
        this.excelFile = null;
        this.importDialog = false;
      },
      importExcel () {
        if (!this.excelFile) {
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: 'Debe seleccionar un archivo Excel.',
          };
          return;
        }

        this.overlay = true;
        this.trainingProviderService.importExcel(this.excelFile).then(response => {
          this.overlay = false;
          this.importDialog = false;
          this.excelFile = null;
          this.loadData();
          this.snackbar = {
            display: true,
            title: 'ÉXITO: ',
            type: 'success',
            message: response.message,
          };
        }).catch((error) => {
          this.overlay = false;
          this.snackbar = {
            display: true,
            title: 'ERROR: ',
            type: 'error',
            message: getErrorMessage(error.response?.data?.message || 'Error al importar el archivo'),
          };
        });
      },
    },

  };
</script>
